import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const verifyAppAction = createAsyncThunk(
    'verify-app',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/admins/api/verify-app`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const verifyAppSlice = createSlice({
    name: 'verify-app',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(verifyAppAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(verifyAppAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(verifyAppAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const verifyAppReducer = verifyAppSlice.reducer